import React from 'react';
import Icon from '../../partials/Icons';

import './ProgressMeter.scss'

const ProgressMeter = ({ questions }) => {
  
  console.log(questions)
  
  return <div className="ProgressMeter">
    {
      questions.map((question, index) => {
        return <CorrectIncorrect key={index} value={question.correct} />
      })
    }
  </div>
};

const CorrectIncorrect = ({
  value
}) => {
  return <div className="check">
    { !(typeof value !== "boolean") && <Icon name={value ? 'check' : 'incorrect'} /> }
  </div>
};

export { ProgressMeter, CorrectIncorrect };
